import utils from 'lib/utils';

class LoadService {
  static async load(files) {
    try {
      const fileEntries = Object.entries(files);
      if (fileEntries.length === 1) {
        const [key, path] = fileEntries[0];
        return LoadService.getRequestFromPath(path, key);
      }
      const promises = [];
      fileEntries.forEach(([key, path]) => {
        const request = LoadService.getRequestFromPath(path, key);
        promises.push(request);
      });
      return Promise.all(promises).then(resolvedPromises => {
        return resolvedPromises.reduce((prev, data) => ({ ...prev, ...data }), {});
      });
    } catch (error) {
      console.error(error);
    }
  }
  static getRequestFromPath(path, key) {
    const url = utils.coursePath(path);
    return fetch(url)
      .then(v => v.json())
      .then(data => (key ? { [key]: data } : data))
      .catch(err => {
        console.error(`Load Service failed at fetch: ${err}`);
        // Returning key undefined to show unsuccessful result
        return { [key]: undefined };
      });
  }
}

export default LoadService;
